export default __webpack_public_path__ + "static/media/angle-double-left.1954f02c.svg";